import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Login from "../views/Unauthorised/Login";
import ResetPassword from "../views/Unauthorised/ResetPassword";

class UnauthenticatedRouter extends React.Component {

    render() {

        return <BrowserRouter>
            <Switch>
                <Route exact path="/reset-password">
                    <ResetPassword {...this.props.childProps} />
                </Route>
                <Route path="/">
                    <Login {...this.props.childProps} />
                </Route>
            </Switch>
        </BrowserRouter>

    }

}

export default UnauthenticatedRouter;